<template>
  <div class="pc__live-chat__not-chat" v-if="!usePCCurrentChatRoom().value">
    <PCEmpty title-text="" />
  </div>
  
  <div class="pc__live-chat__chat-content__wrapper">
    <div class="chat__content" id="pc__live-chat__content">
      <div
        id="pc__live-chat__inner-content"
        :style="{ paddingTop: otherInfo ? '120px' : '0px' }"
      >
        <div class="pc__live-chat__other-card" v-if="otherInfo">
          <!-- {{  otherInfo  }} -->
          <div class="other-card__product">
            <div class="product__inner">
              <MessageProductCard v-if="otherInfo.msgType === 3" :product-info="otherInfo.product!" :chat-first-page="chatFirstPage" />
              <MessageOrderCard v-if="otherInfo.msgType === 4" :order-info="otherInfo.order!" />

              <div class="close-icon" @click="handleCloseCardClick">
                <van-icon name="cross" size="22" />
              </div>
            </div>
  
            <van-button
              class="send-btn"
              size="small"
              type="primary"
              @click="handleSendMsgClick(otherInfo.msgType)"
            >Send</van-button>
          </div>
        </div>
        <div v-for="msg in msgList" :key="msg.msgId" class="chat__msg-item">
          <div
            class="chat__msg-item-content"
            :style="{ justifyContent: msg.userType === 1 ? 'flex-end' : 'flex-start'}"
          >
            <img
              v-if="msg.userType !== 1"
              class="chat__avatar" 
              v-lazy="$cvWebpFn(roomInfo?.store_info?.store_icon || '')"
            >
  
            <div class="chat__msg-content">
              <!-- 1. 文本消息 -->
              <p v-if="msg.msgType === 1" class="msg-text padding-20px" v-html="msg.msgContent" />
  
              <!-- 2. 图片信息 -->
              <div v-if="[2, -1, -2].includes(msg.msgType)" class="image-msg">
                <img v-lazy="$cvWebpFn(msg.msgContent as string, { w: 300 })" alt="" @load="handleImgLoad">
                <span class="loading" v-show="msg.msgType === -1">
                  <van-loading />
                </span>
              </div>
  
              <div v-if="[5, -3, -4].includes(msg.msgType)" class="video-msg">
                <KVideoPlayer :src="(msg.msgContent as string)" :w="300" :h="170" />
              
                <span class="loading" v-show="msg.msgType === -1">
                  <van-loading />
                </span>
              </div>
  
              <div class="video"></div>
  
              <!-- 3. 商品卡片 -->
              <div v-if="msg.msgType === 3" class="product-msg padding-20px">
                <MessageProductCard :product-info="(msg.msgContent as Msg.IMsgProduct)" :msg-user-type="msg.userType" :chat-first-page="chatFirstPage" />          
              </div>
  
              <!-- 7：优惠券 -->
              <div class="voucher-msg" v-if="msg.msgType === 7" @click="handleGetVoucherClick(msg.msgContent)">
                <VoucherItemV2 :item="getVoucher(msg.msgContent)" :hiddenOpt="true" />
              </div>
  
              <!-- 订单信息 -->
              <div class="padding-20px order-msg" v-if="msg.msgType === 4">
                <MessageOrderCard :order-info="(msg.msgContent as Msg.IMsgOrder)" />
              </div>
  
              <p class="msg-time">{{ msg.msgDate }}</p>
            </div>
  
            <img
              v-if="msg.userType === 1"
              class="chat__avatar"
              v-lazy="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/message/icon_user_header.png')"
            >
          </div>
        </div>
      </div>
    </div>
    
    <div class="chat__send-msg">
      <div class="chat__toolbar">
        <!-- 颜文字 -->
        <!-- <EmojiTool @select:emoji="handleEmojiClick" /> -->
        <!-- 图片/视频 -->
        <MediaTool @send:msg="handleSendMediaClick" />
      </div>
      <div class="chat__send-msg-content">
        <van-field
          v-model="message"
          rows="4"
          autosize
          show-word-limit
          type="textarea"
          maxlength="200"
          placeholder="Please enter chat content."
          @keydown.enter="handleEnterMsg"
        />
      </div>
    </div>
  
    <div class="chat__opt-bar">
      <van-button size="small" class="chat__btn" @click="handleCloseClick">Cancel</van-button>
      <van-button
        size="small"
        class="chat__btn"
        style="margin-left: 20px;"
        type="primary"
        @click="handleSendMsgClick(1)"
      >Send</van-button>
    </div>
  </div>
</template>
  
<script setup lang="ts">
import { type Voucher, postVoucher, getVoucherDetailById } from '@/api/models/userInfo'
import { toLiveChatSource } from '@/pages-listing-detail/mixins'
import { type LiveChatFirstPage } from '@/plugins/utils'
import MediaTool from './tool/Media.vue'
import EmojiTool from './tool/Emoji.vue';

const { $msgSocket, $debounce, $throttle } = useNuxtApp()
const roomInfo = ref<Msg.IExtraInfo>()
const msgList = ref<Msg.IMsgContent[]>([])
const loading = ref<boolean>(false)
const loadOver = ref<boolean>(false)

const resolveChatFirstPageFromOpenRoomInfo = (): LiveChatFirstPage => {
  const info = usePCOpenRoomInfo().value
  if (!info) return 'messageCenter'
  if (info.chatFirstPage) return info.chatFirstPage
  if (info.product?.goodsId) return 'productDetail'
  if (info.store?.storeId) return 'store'
  return 'messageCenter'
}

const chatFirstPage = computed(() => useLiveChatFirstPage().value || 'messageCenter')

const afterFn = (roomId: string) => {
  loading.value = true
  $msgSocket.messageAfter({ room_id: roomId, time_after: 0 }, async(r:any) => {
    usePCRoomMsgList().value[roomId!] = r as Msg.IMsgContent[]

    msgList.value = r as Msg.IMsgContent[]

    loading.value = false
  })

  setTimeout(() => { loading.value = false }, 1000)

  if(roomId && usePCRoomMsgList().value[roomId]) {
    msgList.value = usePCRoomMsgList().value[roomId]
    return
  }
}

const handleCloseCardClick = () => {
  usePCOpenRoomInfo().value = null
}

const joinRoom = async(type: 'switch' | 'mount' = 'mount') => {
  if (type === 'mount') {
    // 对齐 WAP：从商详 / 店铺进聊天保留 chat_first_page（productDetail / store）
    useLiveChatFirstPage().value = resolveChatFirstPageFromOpenRoomInfo()
  } else {
    // mount 里自动选中房间会触发 currentRoom watch → switch，不能清掉入口 first_page
    // 仅当用户切到其它店铺会话，或非商详/店铺入口时，才回落 messageCenter
    const openInfo = usePCOpenRoomInfo().value
    const openStoreId = String(
      openInfo?.order?.storeId || openInfo?.product?.storeId || openInfo?.store?.storeId || ''
    )
    const currentStoreId = String(
      usePCCurrentChatRoom().value?.extra_info.store_info.store_id || ''
    )
    const keepEntryFirstPage = !!(
      openInfo?.chatFirstPage
      && openInfo.chatFirstPage !== 'messageCenter'
      && openStoreId
      && openStoreId === currentStoreId
    )
    if (!keepEntryFirstPage) {
      useLiveChatFirstPage().value = 'messageCenter'
    }
  }

  // 如果从 商品 或 订单 进入聊天
  if(usePCOpenRoomInfo().value && type === 'mount') {
    const { order, product, store } = usePCOpenRoomInfo().value || {}
    const openStoreId = order?.storeId || product?.storeId || store?.storeId

    if(openStoreId) {
      const curRoomIdx = useRoomList().value.findIndex((c: Msg.IRoom) => c.extra_info.store_info.store_id === String(openStoreId))
      let curRom

      if(curRoomIdx >= 0) {
        curRom = useRoomList().value[curRoomIdx]

        useRoomList().value.splice(curRoomIdx, 1)
        useRoomList().value.unshift(curRom)
      }
      
      usePCCurrentChatRoom().value = curRom || null
    }
  }

  let currentRoom = usePCCurrentChatRoom().value
  let roomId = currentRoom?.room_id

  if(!roomId) {
    if(!usePCOpenRoomInfo().value) {
      return
    }

    const { order, product, store } = usePCOpenRoomInfo().value!
    const {
      storeId: store_id,
      storeName: store_name,
      storeIcon: store_icon
    } = (order || product || store)!

    const parmas: Msg.IStoreInfo = {
      store_id: String(store_id),
      store_name,
      store_icon
    }

    $msgSocket.createRoom(parmas, (res: any) => {
      roomInfo.value = {
        last_service_user: '',
        store_info: res.extra_info.store_info,
        user_info: res.extra_info.user_info
      }

      roomId = res.id

      setTimeout(() => {
        const curRoom = useRoomList().value.find((c: Msg.IRoom) => c.room_id === roomId)

        if(curRoom) {
          usePCCurrentChatRoom().value = curRoom
        }
        afterFn(roomId as string)
      }, 50)
    })
  } else {
    $msgSocket.joinRoom(roomId, (res: Msg.IExtraInfo) => {
      roomInfo.value = res

      afterFn(roomId as string)
    })
  }
}

watch(
  () => useConnectStatus().value,
  async () => {
    if(useConnectStatus().value === 'success') {
      await joinRoom()
    }
  }
)

let lastElH: number = 0
let oldContentScrollTop: number = 0

watch(
  /** 新消息 滚动条逻辑 */
  () => msgList.value.length,
  async () => {
    const el = document.getElementById('pc__live-chat__content') as HTMLElement
    
    // 如果是最新的消息位置，则滚动到最底部，否则不处理
    if(oldContentScrollTop >= el.scrollHeight - el.clientHeight - 1) {
      await scrollToBottom()
    }
  }
)
const scrollToBottom = (type?: 'more') => {
  const el = document.getElementById('pc__live-chat__content') as HTMLElement

  nextTick().then(() => {
    // setTimeout(() => {
      
    // }, 100)

    const scrollTop = el.scrollHeight - lastElH

    oldContentScrollTop = scrollTop
    el.scrollTop = type === 'more' ? scrollTop : el.scrollHeight
  })
}

const handleImgLoad = $debounce(() => scrollToBottom, 100)

const handleScroll = $throttle((e: any) => {
  if(!usePCCurrentChatRoom().value) {
    return
  }

  const { room_id: roomId } = usePCCurrentChatRoom().value!
  oldContentScrollTop = e.target.scrollTop
  // onLoad
  if(e.target.scrollTop <= 100 && !loading.value && !loadOver.value) {
    loading.value = true
    
    const time_before = msgList.value[0]?.msgStamp || 0
    const params = {
      room_id: roomId,
      time_before
    }
    
    $msgSocket.messageBefore(
      params,
      async(r: any) => {
        loadOver.value = r.length <= 0
        msgList.value.unshift(...r)
        lastElH = contentEl?.scrollHeight || 0
        scrollToBottom('more')

        loading.value =false
      }
    )

    setTimeout(() => { loading.value = false }, 1000)
  }
}, 20)

let contentEl: HTMLElement
const init = async(type: 'switch' | 'mount' = 'mount') => {
  // 切换房间重置标志位
  loadOver.value = false

  joinRoom(type)
  await nextTick()
  setTimeout(scrollToBottom, 100)
}

const mounted = async() => {
  const el = document.getElementById('pc__live-chat__inner-content') as HTMLElement

  if(!el) { return }
  if(usePCLiveChatPopupShow().value) {
    lastElH = 0
    await init('mount')
    
    contentEl = document.getElementById('pc__live-chat__content') as HTMLElement
    
    el.style.width = `${contentEl.clientWidth - 12}px`
  } else {
    el.style.width = '0px'
  }
}

watch(() => usePCCurrentChatRoom().value, () => { init('switch') })
watch(() => usePCLiveChatPopupShow().value, mounted)

const otherInfo = computed(() => {
  if(!usePCCurrentChatRoom().value || !usePCOpenRoomInfo().value) {
    return
  }
  const { product, order } = usePCOpenRoomInfo().value!
  const sid = String((product || order)?.storeId)
  if(!sid || sid !== usePCCurrentChatRoom().value?.extra_info.store_info.store_id ) {
    return
  }

  return usePCOpenRoomInfo().value
})

onMounted(() => {
  contentEl = document.getElementById('pc__live-chat__content') as HTMLElement

  mounted()

  contentEl.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  contentEl && contentEl.removeEventListener('scroll', handleScroll)
})

const message = ref<string>('')
const handleEmojiClick = (e: string) => {
  message.value += e
}
const handleEnterMsg = (e: KeyboardEvent) => {
  e.preventDefault()

  if(!message.value) {
    showToast('Please enter chat content first.')
    return
  }
  handleSendMsgClick(1)
}
const handleSendMsgClick = (msgType: number, src?: string) => {
  const { room_id } = usePCCurrentChatRoom().value || {}
  if(!room_id) {
    return
  }
  if(msgType === 1 && !message.value) {
    return
  }

  let content: string = message.value
  // 订单信息
  if(msgType === 4) {
    const { payAmount, orderId, orderSerial, orderDate, orderUnit, orderAmount, items } = otherInfo.value!.order!

    const orderMsgContent = {
      orderSerial,
      orderDate,
      orderUnit,
      orderId,
      orderAmount,
      payAmount,
      goods: items.map((c: any) => ({ goodsPic: c.image }))
    }
    content = JSON.stringify(orderMsgContent)
    usePCOpenRoomInfo().value = null
  }
  // 商品信息
  if(msgType === 3) {
    const { goodsId, goodsName, goodsPic, goodsUnit, goodsPrice } = otherInfo.value!.product!
    const source = otherInfo.value!.product!.source || otherInfo.value?.source || ''

    content = JSON.stringify({
      goodsId,
      goodsName,
      goodsPic,
      goodsUnit,
      goodsPrice,
      source: toLiveChatSource(source)
    })
    usePCOpenRoomInfo().value = null
  }

  if(msgType === 2 || msgType === 5) {
    if(src) {
      content = src
    }
  }

  const params: Msg.ISendMsg = {
    room_id,
    content,
    message_type: msgType
  }
  
  $msgSocket.sendMsgAsync(params, async() => {
    message.value = ''
    await scrollToBottom()
  })
}

const mediaSendMap: IAnyObject = {}
const handleSendMediaClick = (res: any) => {
  const { msgType, content, status, filename } = res

  const localMsg = $msgSocket.formatMessageContent([
    filename,
    '1000001',
    "-1",
    content,
    `${new Date().getTime()}`,
    "1"
  ])

  if(status === 'loading') {
    localMsg.msgType = msgType === 5 ? -3 : -1
  }
  if(status === 'fail') {
    localMsg.msgType = msgType === 5 ? - 4 : -2
  }
  
  if(status === 'success') {
    handleSendMsgClick(msgType, content)

    // 这里要重新获取索引，因为会受新消息影响
    const _idx = msgList.value.findIndex((item: any) => mediaSendMap[item.msgId])

    if(_idx >= 0) {
      msgList.value.splice(_idx, 1)
    }
  } else {
    const _idx = msgList.value.findIndex((item: any) => mediaSendMap[item.msgId])
    
    if(_idx < 0) {
      mediaSendMap[filename] = localMsg
      msgList.value.push(localMsg)
    } 
  }
}

const getVoucher = (item: any): Voucher => {
  return {
    ...JSON.parse(item || '{}'),
    voucherType: 1,
    isEarned: false,
    status: 0
  }
}
const handleGetVoucherClick = async(msg: any) => {
  const { genId } = getVoucher(msg)
  const catchKey: string = `voucher_${genId}`
  // 缓存机制
  const _catchGens = sessionStorage.getItem(catchKey)
  let gen = _catchGens ? JSON.parse(_catchGens) : null

  if(!gen) {
    const { gens:_gens = [] } = await getVoucherDetailById(genId as number)

    gen = _gens[0]

    if(gen) {
      sessionStorage.setItem(catchKey, JSON.stringify(gen))
    } else {
      showToast(`Coupon collection failed.`)
      return
    }
  }

  const { status, isEarned, remainNumber } = gen
  const isGetNow = !status && !isEarned && remainNumber > 0

  if(!isGetNow) {
    showToast('Coupon has been collected.')
    return
  }

  try {
    await postVoucher({ genId, receiveScene: 'BUYER_SELLER_CHAT' }, true)

    showToast('Coupon received successfully.')
  } catch(e) {
    console.error(e)
  }
}

const handleCloseClick = () => {
  usePCLiveChatPopupShow().value = false
}
</script>
  
<style lang="scss" scoped>
</style>
